module.exports = __webpack_public_path__ + "src/components/@organisms/Header/images/Ae8xEae.svg";